import { queryOptions, useQuery } from "@tanstack/react-query";

import data from "../../assets/mocks/market-performance.json";
import { getDataFilteredByRange, mapPayloadToPortfolioPerfomance } from "./utils";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";
import { AxiosMock } from "@/utils/mock";

import type { QueryConfig } from "@/lib/react-query";
import type { DatesRange } from "@/types/entity";
import type { Performance, PortfolioPayload } from "@/types/performance";

type PerformanceParams = Partial<DatesRange>;

if (import.meta.env.MODE === "test") {
  // Mocking the API response for makes
  const mock = AxiosMock.getInstance();
  mock.onGet("/carburate/portfolio/performance/").reply(200, data);
}

export const getPortfolioPerformance = async () => {
  const response = (await api.get(`/carburate/portfolio/performance/`)) as PortfolioPayload;
  return mapPayloadToPortfolioPerfomance(response, "portfolio");
};

export const getPortfolioPerformanceQueryOptions = () => {
  return queryOptions({
    queryKey: ["portfolio", "performance"],
    queryFn: () => getPortfolioPerformance(),
  });
};

type UsePortfolioPerformanceOptions = PerformanceParams & {
  queryConfig?: QueryConfig<typeof getPortfolioPerformance>;
};

export const usePortfolioPerformance = ({
  from,
  queryConfig,
  to,
}: UsePortfolioPerformanceOptions = {}) => {
  let data: Performance;

  const {
    data: response,
    isSuccess,
    ...props
  } = useQuery({
    enabled: hasAccessToken(),
    ...getPortfolioPerformanceQueryOptions(),
    ...queryConfig,
  });

  data = response!;
  if (isSuccess) {
    data = getDataFilteredByRange(data, from && to ? { from, to } : undefined);
  }

  return { data, isSuccess, ...props };
};
